import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/images/logo1.png'


const _hoisted_1 = { class: "logo position-absolute start-0 end-0 top-0 bg-black" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo-icon",
  style: {"height":"90px","width":"150px"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-caret-double-right" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "sidebar-menu" }
const _hoisted_6 = {
  key: 0,
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_7 = { class: "sidebar-nav-item bg-transparent" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-more-1" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Dashboard", -1)
const _hoisted_10 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseTwo",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseTwo"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-setting" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Administración")
], -1)
const _hoisted_12 = {
  id: "sidebarCollapseTwo",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_13 = { class: "accordion-body" }
const _hoisted_14 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled bg-transparent" }
const _hoisted_15 = { class: "sidebar-sub-menu-item bg-transparent" }
const _hoisted_16 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseNine",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseNine"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-trophy" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Juegos")
], -1)
const _hoisted_18 = {
  id: "sidebarCollapseNine",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_19 = { class: "accordion-body" }
const _hoisted_20 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_21 = { class: "sidebar-sub-menu-item" }
const _hoisted_22 = { class: "sidebar-sub-menu-item" }
const _hoisted_23 = { class: "sidebar-sub-menu-item" }
const _hoisted_24 = { class: "sidebar-sub-menu-item" }
const _hoisted_25 = { class: "sidebar-sub-menu-item" }
const _hoisted_26 = { class: "sidebar-sub-menu-item" }
const _hoisted_27 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseTwelve",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseTwelve"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-book" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Secciones Educativas")
], -1)
const _hoisted_29 = {
  id: "sidebarCollapseTwelve",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_30 = { class: "accordion-body" }
const _hoisted_31 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_32 = { class: "sidebar-sub-menu-item" }
const _hoisted_33 = { class: "sidebar-sub-menu-item" }
const _hoisted_34 = { class: "sidebar-nav-item" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-logout" }, null, -1)
const _hoisted_36 = {
  key: 1,
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_37 = { class: "sidebar-nav-item bg-transparent" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-trophy" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Ganadores", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: _ctx.stateStoreInstance?.open },
    ]),
    id: "sidebar-area"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "d-flex align-items-center text-white text-decoration-none"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createElementVNode("button", {
        class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
      }, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (
          (_ctx.currentUser?.groups &&
            _ctx.currentUser.groups.length > 0 &&
            _ctx.currentUser.groups[0].id == 1) ||
          (_ctx.currentUser?.compressed?.groups &&
            _ctx.currentUser.compressed?.groups.length > 0 &&
            _ctx.currentUser.compressed?.groups[0].id == 1)
        )
        ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("ul", _hoisted_14, [
                    _createElementVNode("li", _hoisted_15, [
                      _createVNode(_component_router_link, {
                        to: "/users-list",
                        class: "sidebar-sub-menu-link bg-transparent"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Usuarios ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        to: "/route-list",
                        class: "sidebar-sub-menu-link bg-transparent"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Rutas ")
                        ]),
                        _: 1
                      }),
                      (
                      (_ctx.currentUser?.groups &&
                        _ctx.currentUser.groups.length > 0 &&
                        _ctx.currentUser.groups[0].id == 1) ||
                      (_ctx.currentUser?.compressed?.groups &&
                        _ctx.currentUser.compressed?.groups.length > 0 &&
                        _ctx.currentUser.compressed?.groups[0].id == 1)
                    )
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: "/app-version-list",
                            class: "sidebar-sub-menu-link bg-transparent"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Versionado de la Aplicación ")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("li", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("ul", _hoisted_20, [
                    _createElementVNode("li", _hoisted_21, [
                      _createVNode(_component_router_link, {
                        to: "/game-list",
                        class: "sidebar-sub-menu-link bg-transparent"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Gestionar Juego ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_22, [
                      _createVNode(_component_router_link, {
                        to: "/games-user-list",
                        class: "sidebar-sub-menu-link bg-transparent"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Listado de Jugadores ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_23, [
                      _createVNode(_component_router_link, {
                        to: "/games-winner-list",
                        class: "sidebar-sub-menu-link bg-transparent"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Listado de Ganadores ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_24, [
                      _createVNode(_component_router_link, {
                        to: "/levels-list",
                        class: "sidebar-sub-menu-link bg-transparent"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Gestionar Niveles ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_25, [
                      _createVNode(_component_router_link, {
                        to: "/questions-list",
                        class: "sidebar-sub-menu-link bg-transparent"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Gestionar Preguntas ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_26, [
                      _createVNode(_component_router_link, {
                        to: "/answers-list",
                        class: "sidebar-sub-menu-link bg-transparent"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Posibles Respuestas ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("li", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("ul", _hoisted_31, [
                    _createElementVNode("li", _hoisted_32, [
                      _createVNode(_component_router_link, {
                        to: "/educ-sections-list",
                        class: "sidebar-sub-menu-link bg-transparent"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Secciones Educativas ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_33, [
                      _createVNode(_component_router_link, {
                        to: "/topic-list",
                        class: "sidebar-sub-menu-link bg-transparent"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Agregar Tópicos ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("li", _hoisted_34, [
              _createVNode(_component_router_link, {
                to: "",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => [
                  _hoisted_35,
                  _createElementVNode("span", {
                    class: "title",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"]))
                  }, "Cerrar Sesión")
                ]),
                _: 1
              })
            ])
          ]))
        : (
          (_ctx.currentUser?.groups &&
            _ctx.currentUser.groups.length > 0 &&
            _ctx.currentUser.groups[0].id == 2) ||
          (_ctx.currentUser?.compressed?.groups &&
            _ctx.currentUser.compressed?.groups.length > 0 &&
            _ctx.currentUser.compressed?.groups[0].id == 2)
        )
          ? (_openBlock(), _createElementBlock("ul", _hoisted_36, [
              _createElementVNode("li", _hoisted_37, [
                _createVNode(_component_router_link, {
                  to: "/games-winner-list",
                  class: "sidebar-nav-link d-block"
                }, {
                  default: _withCtx(() => [
                    _hoisted_38,
                    _hoisted_39
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
    ])
  ], 2))
}